export const WITHDRAWAL_EMPLOYEE_ROLE = 'withdrawal_employee';
export const WITHDRAWAL_EMPLOYEE_HOME = '/employee/withdrawals';
const EMPLOYEE_ROUTES = [WITHDRAWAL_EMPLOYEE_HOME, '/refer', '/refer/view'];

export const isWithdrawalEmployee = admin => (
  admin && (admin.admin_role === WITHDRAWAL_EMPLOYEE_ROLE
    || admin.roles === WITHDRAWAL_EMPLOYEE_ROLE
    || admin.account_type === WITHDRAWAL_EMPLOYEE_ROLE)
);

export const routesForAdmin = (routes, admin) => {
  if (!isWithdrawalEmployee(admin)) return routes;
  return routes.filter(route => EMPLOYEE_ROUTES.includes(route.path));
};
